var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{attrs:{"img-src":_vm.gift.gift_image,"title":_vm.gift.gift_title}},[_c('p',[_vm._v("score : "+_vm._s(_vm.gift.gift_score))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }